
    import * as React from 'react';

    const GenderMens12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M6 2L2 6l4 4 4-4-3.998-4z" fillRule="evenodd" /></svg>
        </div>
      );
    };

    GenderMens12.displayName = 'GenderMens12';

    export default GenderMens12;
  